import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationCardComponent } from './components/configuration-card.component';
import { ConfigurationContainerComponent } from './configuration.container';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../../material.module';
import { AddAccessGroupDialogComponent } from './components/add-access-group-dialog.component';
import { FilterGroupsPipe } from './pipes/access-group-filter.pipe';


@NgModule({
  declarations: [ConfigurationContainerComponent, ConfigurationCardComponent, AddAccessGroupDialogComponent, FilterGroupsPipe ],
  imports: [
    CommonModule,
    MaterialModule,
    NgxPermissionsModule.forChild(),
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ConfigurationContainerComponent, ConfigurationCardComponent, ],
  entryComponents: [AddAccessGroupDialogComponent]
})
export class ConfigurationModule { }
